<div class="swiper-container-vertical-image">
  <div class="swiper-wrapper" #carouselVertical>
    <div *ngFor="let item of items; let i = index" class="swiper-slide">
      <div
        class="gallery-item hover-gallery"
        [ngClass]="brand === 'avantrip' ? 'default-img-avantrip' : 'default-img-almundo'"
        (click)="itemClick.emit(i)"
      >
        <img backgroundImage="true" [src]="item?.url" class="gallery-img" />
      </div>
    </div>
  </div>
</div>
